// Module-level access-token store. Phase 2 auth-hardening moved the access
// token out of localStorage and into in-memory state to remove the XSS-steal
// surface. Service code (which is plain TS, not React) reads via getter; the
// AuthContext owns mutation via setAccessToken / clearAccessToken.

let accessToken: string | null = null;

// Subscribers are notified on every mutation so React components (notably
// AuthContext) can re-render when the token is rotated or cleared by a
// refresh-on-401 cycle that happens outside their reach.
type Listener = (token: string | null) => void;
const listeners = new Set<Listener>();

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
  for (const fn of listeners) fn(token);
}

export function clearAccessToken(): void {
  setAccessToken(null);
}

export function subscribeAccessToken(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
